// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__C0T5a","content":"GlobalSearch_content__PwbGt"};